import React, { useEffect } from 'react';
import {
  useLocation,
  useNavigate,
  useParams,
  Routes,
  Route,
  useMatch,
  useSearchParams
} from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { connect, useSelector } from 'react-redux';
import { AssetMapping } from '../pages';
import SmartControlTags from '../pages/Modules/Custom/SmartControl/SmartControlTags';

import {
  IdleTimeout,
  GenericPageNotFound,
  SettingsPage,
  ChatApplication,
  ChatUploadChatApplication,
  FileuploadChatApplication,
  DefaultLandingPage,
  AllModulesList,
  EquipmentOverview,
  CraneStatus,
  CMRLFaults,
  TrainStatus,
  HMI,
  ModuleWiseSVG,
  ViewDashboard,
  EditDashboard,
  ViewDashboardGroup,
  RulesList,
  RuleEngine,
  RulesFeedback,
  RuleEngineRootCause,
  DeviceTypeRuleExclusion,
  AMM,
  Reports,
  ELogBookView,
  ViewTrends,
  Trends,
  TrendsAnalysis,
  FormGenerator,
  FormGeneratorLink,
  CustomerAssetDeviceComponent,
  SubDeviceChildren,
  Mod,
  MasterTemplate,
  ParameterSelection,
  DeviceTypes,
  SubEquipments,
  Parameter,
  DeviceTypesChildren,
  StatusConfiguration,
  AssetAttributes,
  AssetTypes,
  AssetType,
  DynamicHierarchy,
  DownTimeLogs,
  XMLConfiguration,
  // XMLConfigurationLists,
  MaximoEdgeConfiguration,
  FileUploadAndDownload,
  MaximoNotification,
  // LookupMasters,
  // LookupMasterItems,
  CmFeedback,
  // ISOReports,
  // ReportTypeConfiguration,
  Analytics_V1,
  Analytics_V2,
  Home,
  SmartControl,
  InHouseRegistration,
  MoistureSensor,
  UseCase,
  TasksAnalytics,
  TrainingJobs,
  Analytics,
  AnalyticsDetails,
  AIRulesDetails,
  AIList,
  AIFileUpload,
  RuleEngineMaintainance,
  AssetAttributeList,
  AssetParameter,
  Renderer,
  DigitalTwinConfiguration,
  Hierarchy3D,
  MultiRenderering,
  MultiHierarchy3D,
  TaskScheduler,
  TaskSchedulerDetails,
  PurgeList,
  DailyPowerGenerationReport,
  // AIFaults
  MultilevelDashboard,
  QrList,
  QrDetails,
  AIFaults,
  CustomHierarchy,
  EditAssetsTree,
  ViewAssetsTree,
  ParameterMapping,
  ModuleWiseDashboard,
  // MultilevelDashboard
  SRHaltTime,
  SRWaitInterval,
  StatusScreen,
  StatusScreenAsset,
  WarningDashboard,
  FailureReports,
  FailureReportsMultiple,
  TopicList,
  TopicMaster,
  QuestionsList,
  QuestionsDetails,
  IntervalMasterDetails,
  AMSMapping
} from '../pages';

import RealTimeAssetTracking from '../pages/Modules/Common/DefaultLandingPage/RealTimeAssetTracking';
import TurbineOverview from '../pages/Modules/Common/DefaultLandingPage/TurbineHomePage';
import ErrorBoundaryWithNavigate from '../pages/3D/Error/errorWrapper';

const HomePageRouter = (props) => {
  const themeValue = useSelector((state) => state.ThemeReducer);

  const dynamicRouteRender = (routes) => {
    return (
      routes &&
      Array.isArray(routes) &&
      routes.map((route, index) => {
        return <Route key={index} {...route} />;
      })
    );
  };

  useEffect(() => {
    document.title = 'Rubus-Industrial IoT Platform';
  }, []);

  const { location, navigate, params, match } = props;
  const propsData = { location, navigate, params, history, match };
  let routes = [
    { path: '/settingsPage/*', element: <SettingsPage {...propsData} /> },

    { path: '/ChatApplication', element: <ChatApplication {...propsData} /> },
    { path: '/ChatApplication/upload', element: <ChatUploadChatApplication {...propsData} /> },
    { path: '/ChatApplication/fileupload', element: <FileuploadChatApplication {...propsData} /> },
    { path: '/Maximo/:BMS/SRHaltTime', element: <SRHaltTime {...props} /> },
    { path: '/Maximo/:BMS/SRWaitInterval', element: <SRWaitInterval {...props} /> },
    { path: '/Maximo/:BMS/StatusScreen', element: <StatusScreen {...props} /> },
    { path: '/Maximo/:BMS/StatusScreenAsset', element: <StatusScreenAsset {...props} /> },

    { path: '/AMM/*', element: <AMM {...propsData} /> },
    { path: '/RbsAnalytics/*', element: <Analytics_V2 {...propsData} /> },
    { path: '/RbsAnalytics/*', element: <Analytics_V1 {...propsData} /> },
    { path: '/RubusAnalytics/home', element: <Home {...propsData} /> },
    { path: '/RubusAnalytics/usecase', element: <UseCase {...propsData} /> },
    { path: '/RubusAnalytics/usecase/:id', element: <UseCase {...propsData} /> },
    { path: '/RubusAnalytics/Tasks', element: <TasksAnalytics {...propsData} /> },
    { path: '/RubusAnalytics/Tasks/:id', element: <TasksAnalytics {...propsData} /> },
    { path: '/RubusAnalytics/TrainningJob', element: <TrainingJobs {...propsData} /> },
    { path: '/RubusAnalytics/TrainningJob/:id', element: <TrainingJobs {...propsData} /> },
    { path: '/RbsAnalytics/UseCase', element: <Analytics {...propsData} /> },
    { path: '/RbsAnalytics/UseCaseDetails/:id', element: <AnalyticsDetails {...propsData} /> },

    { path: '/LandingPage', element: <DefaultLandingPage {...propsData} /> },
    { path: '/CraneStatus', element: <CraneStatus {...propsData} /> },
    { path: '/CentralDashboard', element: <AllModulesList {...propsData} /> },
    { path: '/EquipmentOverview', element: <EquipmentOverview {...propsData} /> },
    { path: `/CMRLFaults`, element: <CMRLFaults {...propsData} /> },
    { path: `/TrainStatus`, element: <TrainStatus {...propsData} /> },

    {
      path: '/3d/:Type/:Name',
      element: (
        <ErrorBoundaryWithNavigate key={location.pathname}>
          <Renderer {...propsData} />
        </ErrorBoundaryWithNavigate>
      )
    },
    {
      path: '/3dm/:Type/:Name',
      element: (
        <ErrorBoundaryWithNavigate key={location.pathname}>
          <MultiRenderering {...propsData} />
        </ErrorBoundaryWithNavigate>
      )
    },
    {
      path: '/DigitalTwinConfiguration',
      element: (
        <ErrorBoundaryWithNavigate key={location.pathname}>
          <DigitalTwinConfiguration {...propsData} />
        </ErrorBoundaryWithNavigate>
      )
    },
    {
      path: '/DigitalTwin/:type/:name',
      element: (
        <ErrorBoundaryWithNavigate key={location.pathname}>
          <Hierarchy3D {...propsData} />
        </ErrorBoundaryWithNavigate>
      )
    },
    {
      path: '/DigitalTwinMulti/:type/:name',
      element: (
        <ErrorBoundaryWithNavigate key={location.pathname}>
          <MultiHierarchy3D {...propsData} />
        </ErrorBoundaryWithNavigate>
      )
    },
    { path: '/HMI/:type/:hmiName', element: <HMI {...propsData} /> },
    { path: '/HMI/:type/:hmiName/:dynamicName/:selectionType', element: <HMI {...propsData} /> },
    { path: '/ModuleWiseHMI/:module', element: <ModuleWiseSVG {...propsData} /> },

    { path: '/MaximoXMLConfiguration', element: <XMLConfiguration {...propsData} /> },
    { path: '/MaximoEdgeConfiguration', element: <MaximoEdgeConfiguration {...propsData} /> },
    { path: '/MaximoNotification', element: <MaximoNotification {...propsData} /> },
    { path: '/InHouseRegistration', element: <InHouseRegistration {...propsData} /> },
    { path: `/form/MoistureSensor1/*`, element: <MoistureSensor {...propsData} /> },

    { path: '/Trends', element: <Trends {...propsData} /> },
    { path: '/Trends/:module', element: <Trends {...propsData} /> },
    { path: '/ViewTrends/:id', element: <ViewTrends {...propsData} /> },
    { path: '/TrendsAnalysis', element: <TrendsAnalysis {...propsData} /> },

    { path: '/AIRulesList', element: <AIList {...propsData} /> },
    { path: '/AIFaults', element: <AIFaults {...propsData} /> },
    { path: '/RulesList', element: <RulesList {...propsData} /> },
    { path: '/RuleEngine', element: <RuleEngine {...propsData} /> },
    { path: '/RuleEngine/:id', element: <RuleEngine {...propsData} /> },
    { path: '/RulesFeedback', element: <RulesFeedback {...propsData} /> },
    { path: '/AI/fileupload', element: <AIFileUpload {...propsData} /> },
    { path: '/AIRulesDetails', element: <AIRulesDetails {...propsData} /> },
    { path: '/Rule/RootCause', element: <RuleEngineRootCause {...propsData} /> },
    { path: '/Rule/Maintainance', element: <RuleEngineMaintainance {...propsData} /> },
    { path: '/DeviceTypeRuleExclusion', element: <DeviceTypeRuleExclusion {...propsData} /> },

    { path: '/editDashboard', element: <EditDashboard {...propsData} /> },
    { path: '/dashboard/:name', element: <ViewDashboard {...propsData} /> },
    { path: '/dashboards/:name', element: <ViewDashboardGroup {...propsData} /> },
    { path: '/multileveldashboard', element: <MultilevelDashboard {...propsData} /> },
    { path: '/dashboard/:name/:deviceCode', element: <ViewDashboard {...propsData} /> },

    { path: '/QrList', element: <QrList {...propsData} /> },
    { path: '/QrDetails/:id', element: <QrDetails {...propsData} /> },

    { path: '/CustomHierarchy', element: <CustomHierarchy {...propsData} /> },
    { path: '/editAssets/:id', element: <EditAssetsTree {...propsData} /> },
    { path: '/viewAssets/:id', element: <ViewAssetsTree {...propsData} /> },

    { path: '/report/:reportType/:report', element: <Reports {...propsData} /> },
    // { path: '/ReportTypeConfiguration', element: <ReportTypeConfiguration {...propsData} /> },

    { path: '/FFT', element: <FormGenerator {...propsData} /> },
    { path: '/FFTLink', element: <FormGeneratorLink {...propsData} /> },

    { path: '/LogBook/:name', element: <ELogBookView {...propsData} /> },
    { path: '/smartcontrol/:formName', element: <SmartControl {...propsData} /> },
    { path: '/smartcontrol', element: <SmartControl {...propsData} /> },
    { path: '/SmartControlTag', element: <SmartControlTags {...propsData} /> },
    { path: '/WarningDashboard', element: <WarningDashboard {...propsData} /> },
    { path: `/map/RealTimeAssetTracking`, element: <RealTimeAssetTracking {...propsData} /> },
    { path: `/map/TurbineOverview`, element: <TurbineOverview {...propsData} /> },
    { path: '/DownTime', element: <DownTimeLogs {...propsData} /> },

    { path: '/CmFeedback', element: <CmFeedback {...propsData} /> },

    { path: '/MeterUploadAndDownload', element: <FileUploadAndDownload {...propsData} /> },
    { path: '/FaultsUploadAndDownload', element: <AssetMapping {...propsData} /> },
    { path: '/EventMapping', element: <AMSMapping {...propsData} /> },
    { path: '/AMS_ParameterUploadAndDownload', element: <ParameterMapping {...propsData} /> },//Done

    // { path: '/LookupMasters', element: <LookupMasters {...propsData} /> },
    // { path: '/LookupMasterItemDetails/:Id', element: <LookupMasterItems {...propsData} /> },

    {
      path: '/CustomerAssetDeviceConfiguration/:module',
      element: <CustomerAssetDeviceComponent {...propsData} />
    },
    { path: '/CustomerAssetDevice/DeviceTypes', element: <DeviceTypes {...propsData} /> },
    { path: '/CustomerAssetDevice/DeviceTypes/:module', element: <DeviceTypes {...propsData} /> },
    { path: '/CustomerAssetDevice/Modules', element: <Mod {...propsData} /> },
    { path: '/CustomerAssetDevice/MasterTemplate', element: <MasterTemplate {...propsData} /> },
    { path: '/CustomerAssetDevice/PlannedHours', element: <ParameterSelection {...propsData} /> },
    { path: '/CustomerAssetDevice/SubEquipments', element: <SubEquipments {...propsData} /> },
    { path: '/CustomerAssetDevice/Parameter', element: <Parameter {...propsData} /> },
    { path: '/CustomerAssetDevice/AssetParameter', element: <AssetParameter {...propsData} /> },
    { path: '/CustomerAssetDevice/AssetType', element: <AssetType {...propsData} /> },
    {
      path: '/CustomerAssetDevice/DeviceTypesChildren/:module',
      element: <DeviceTypesChildren {...propsData} />
    },
    {
      path: '/CustomerAssetDevice/SubDeviceChildren/:module',
      element: <SubDeviceChildren {...propsData} />
    },
    { path: '/ModuleWiseSVG/:module', element: <ModuleWiseDashboard {...propsData} /> },
    {
      path: '/CustomerAssetDevice/StatusConfiguration',
      element: <StatusConfiguration {...propsData} />
    },
    {
      path: '/CustomerAssetDevice/UnCommonAttributes',
      element: <AssetAttributeList {...propsData} />
    },
    { path: '/CustomerAssetDevice/CommonAttributes', element: <AssetAttributes {...propsData} /> },
    { path: '/CustomerAssetDevice/AssetTypes', element: <AssetTypes {...propsData} /> },
    { path: '/CustomerAssetDevice/DynamicHierarchy', element: <DynamicHierarchy {...propsData} /> },

    { path: '/TaskScheduler', element: <TaskScheduler {...propsData} /> },
    { path: '/TaskSchedulerDetails', element: <TaskSchedulerDetails {...propsData} /> },
    { path: '/PurgeList', element: <PurgeList {...propsData} /> },
    { path: '/DailyPowerGenerationReport', element: <DailyPowerGenerationReport {...propsData} /> },
    { path: '/Maximo/IntervalMasterDetails', element: <IntervalMasterDetails {...propsData} /> },
    { path: '/CustomerAssetDevice/TopicMaster', element: <TopicMaster {...propsData} /> },
    { path: '/CustomerAssetDevice/TopicList', element: <TopicList {...propsData} /> },
    { path: '/FRACAS/V1/FailureReports', element: <FailureReports {...propsData} /> },
    { path: '/FRACAS/V2/FailureReports', element: <FailureReportsMultiple {...propsData} /> },
    { path: '/FRACAS/QuestionsList', element: <QuestionsList {...propsData} /> },
    { path: '/FRACAS/QuestionsDetails', element: <QuestionsDetails {...propsData} /> },
    { path: '/FRACAS/QuestionsDetails/:id', element: <QuestionsDetails {...propsData} /> },
    { path: '*', element: <GenericPageNotFound {...propsData} /> }
  ]; 
  //  let colorBgContainer = props && props.themeValue && props.themeValue.token && props.themeValue.token.colorBgContainer;

  return (
    <ConfigProvider
      theme={{
        token: themeValue.token,
        components: themeValue.components,
        algorithm: themeValue.darkAlgorithm
      }}>
      <IdleTimeout timeout={props.userTimeout} {...props} />
      <div style={{ minHeight: window.innerHeight - 155 }}>
        <Routes>{dynamicRouteRender(routes)}</Routes>
      </div>
    </ConfigProvider>
  );
};

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    let searchParams = useSearchParams();
    let match = useMatch(location.pathname);
    let router = { location, navigate, params, match, searchParams };
    return <Component {...props} {...router} />;
  }
  return ComponentWithRouterProp;
}

const mapStateToProps = (state) => ({
  userTimeout: state.LayoutReducer.userTimeout,
  themeValue: state.ThemeReducer
});

export default connect(mapStateToProps)(withRouter(HomePageRouter));
